import {vnModule_knockoutJS} from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import {vn_app_zone_notification} from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";
import {XMLHttpRequestHandler} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {pagination_template} from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/pagination_template";
import {speedTestInsightsLog_template} from "../components/templates/speedTestInsightsLog_template";
import {XMLHttpRequestHandler_requestType} from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";

declare var ko: any;
declare var page: any;

export class speedTestInsightsLog extends vnModule_knockoutJS{

    public XHRHdl: XMLHttpRequestHandler;
    protected speedTestInsightsLog: speedTestInsightsLog_template;
    protected pagination: pagination_template;

    protected getModuleName(){

        return "speedTestInsightsLog";
    }

    buildContent() : Array<Element>{

        this.speedTestInsightsLog = new speedTestInsightsLog_template("speedTestInsightsLog", this.viewModel, this);
        return [this.speedTestInsightsLog.build()];
    }

    public fillPage() : void {

        this.speedTestInsightsLog.setStatusFilterItems();

        this.getListData();
    }


    protected getListData(): void {

        if (this.XHRHdl) {

            this.XHRHdl.cancelAndReset();
        }

        let id = this.getVnAppZone().app.params.id || null;

        // LOADING : starts
        this.loadingIn(this.speedTestInsightsLog.builtTemplate.children.namedItem("list-results"));

        let usrReq_url: string = '/api/speedTest/configInsights/logs/' + id;
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(this.speedTestInsightsLog.getViewModelForRequest())] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);
        this.XHRHdl.onReadyStateFunction = this.onDataRequestReturn;
        this.XHRHdl.execute();
    }

    protected onDataRequestReturn(req, obj): Function {

        return function(){

            obj.manageResponse(req, obj, function(){

                if (req.request.status == 200) {

                    let responseParsed = JSON.parse(req.request.response);
                    obj.updateList(responseParsed);
                }
            });
            obj.loadingOut(obj.speedTestInsightsLog.builtTemplate.children.namedItem("list-results"));
        }
    }

    protected updateList(responseParsed: any): void {

        this.speedTestInsightsLog.setLogs(responseParsed.data);

        // update the paginator
        this.speedTestInsightsLog.setPaginationTotalCount(responseParsed.totalCount);
    }

    protected paginationOnPageClick(): void {

        this.getListData();
    }

    public listReorder(): void {

        this.getListData();
    }

    protected filterSimpleOnChange(): void {

        this.speedTestInsightsLog.resetPageNumber();
        this.getListData();
    }

    protected filterSimpleCancel(): void {

        if( this.XHRHdl ){

            this.XHRHdl.cancelAndReset();
        }
    }

    protected filterMultipleSelectorOnChange(){

        this.getListData();
    }

    public dataReorder(id) {

        this.getListData();
    }

    protected cancel(){

        page.redirect('/speed_test/config_insights/');
    }
}


// WEBPACK FOOTER //
// ./js/modules/speedTestInsightsLog.ts